// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrap-free-text {
  white-space: normal !important;
  word-break: break-word;
}

.nowrap-free-text {
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

.projectPlanTable .task-field-width {
  width: 300px;
}
.projectPlanTable .non-task-width {
  width: 140px;
}
.projectPlanTable .role-field-width {
  width: 160px;
}
.projectPlanTable .customized-min-width {
  width: 90px;
}
.projectPlanTable .taskDuration-min-width {
  width: 110px;
}

.p-confirm-popup {
  position: absolute;
  top: 12% !important;
  left: 0% !important;
}

.p-datepicker table td {
  padding: 0.2px !important;
}

.p-button:focus {
  box-shadow: none !important;
}

.myProjectAnddAllProjectList {
  height: 100%;
  overflow: hidden;
}
.myProjectAnddAllProjectList .p-treetable {
  height: calc(100% - 90px);
  overflow: hidden;
}
.myProjectAnddAllProjectList .p-treetable > .p-treetable-wrapper {
  height: 100%;
  width: 100%;
}
.myProjectAnddAllProjectList .p-treetable > .p-treetable-wrapper .p-treetable-scrollable-view {
  height: 100%;
  overflow: hidden;
}
.myProjectAnddAllProjectList .p-treetable.searchWithTreeTable > .p-treetable-wrapper .p-treetable-scrollable-view .p-treetable-scrollable-body {
  height: calc(100% - 100px);
}
.myProjectAnddAllProjectList .p-datatable > .p-datatable-wrapper {
  overflow: scroll;
  width: 100%;
}
.myProjectAnddAllProjectList .p-datatable-tbody {
  font-weight: 400;
}
.myProjectAnddAllProjectList td,
.myProjectAnddAllProjectList table .p-datatable .p-datatable-tbody > tr > td,
.myProjectAnddAllProjectList th,
.myProjectAnddAllProjectList tr {
  position: relative;
}
.myProjectAnddAllProjectList .input-duration > input {
  max-width: 70px;
  border-radius: 5px;
  text-align: center;
  height: 25px;
}
.myProjectAnddAllProjectList .task-link {
  color: #003da5;
  cursor: pointer;
  line-height: 15px;
  line-break: anywhere;
}
.myProjectAnddAllProjectList table .p-inputtext {
  width: 100% !important;
  font-size: 12px !important;
}
.myProjectAnddAllProjectList table .p-inputtext.p-autocomplete-input {
  padding: 0 5px;
}

.font-bold {
  font-weight: 700;
}

.p-checkbox {
  margin: 8px;
}

.p-checkbox-checked + label {
  color: #003da5;
}

.ml-2 {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
}

/* badge used for wave name display in project plan table */
.wave-name-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  height: 100%;
}

.wave-name-badge_dependency_mapping {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  height: 100%;
  margin-top: -10px;
}

img[disabled] {
  opacity: 0.5;
  cursor: no-drop;
}

.clearAllFilterMainDiv {
  display: flex;
  padding: 10.56px 22px 22px 2px;
}

.clearAllFilterDiv {
  line-height: 12px;
  justify-items: end;
  display: flex;
  position: absolute;
  right: 22px;
  top: 18px;
}

.clearAllFilter {
  cursor: pointer;
}

.clearAllFilterIcon {
  cursor: pointer;
  position: absolute;
  right: 5px;
}

.sortAndFrozen {
  padding: 0 22px 22px 2px;
  cursor: pointer;
  line-height: 12px;
}

.multiSelect {
  cursor: pointer;
  line-height: 10px;
}
.multiSelect .p-placeholder {
  color: #595959 !important;
}
.multiSelect .p-multiselect {
  width: 124px !important;
}

.p-overlaypanel {
  position: absolute !important;
}

.p-multiselect-item {
  font-size: 10px !important;
  line-height: 12px !important;
  padding: 0px 0 !important;
}

.p-inputtext {
  font-size: 10px !important;
  line-height: 12px !important;
  font-family: Montserrat !important;
  color: #000000;
}

.apply-filter-text {
  color: "#003DA5" !important;
}

.duration {
  color: #9a9898;
  background-color: #ffffff !important;
  width: 38px;
  height: 20px;
  border-color: #9a9898;
  border-radius: 4px;
  padding: 0px;
  font-weight: 400;
  font-size: 10px;
}

.helpNeeded {
  color: #ffffff;
  background-color: #01d309 !important;
  width: 48px;
  height: 20px;
  border: none;
  border-radius: 4px;
  padding: 0px;
  font-weight: 500;
  font-size: 12px;
}

.iconsStyle {
  cursor: pointer;
  margin-right: 3.3px;
  width: 13.33px;
  height: 13.33px;
}

.iconsTextStyle {
  color: #03a000;
  font-size: 10px;
  line-height: 12px;
  cursor: pointer;
}

.iconInprogress {
  color: #003da5 !important;
}

.iconLock {
  color: #595959 !important;
}

.iconAwaiting {
  color: #d37302 !important;
}

.iconRejected {
  color: #ff0000 !important;
}

.TaskStyles {
  color: #003da5;
  cursor: pointer;
}

.projectplan-calender .p-calendar {
  display: block;
}
.projectplan-calender .p-inputtext {
  border-radius: 4px !important;
  height: 32px;
}

.textAlignTreeTable .p-treetable-thead .cursorMove {
  cursor: move;
}
.textAlignTreeTable .p-treetable-thead .fontBoldcolor {
  color: #145392;
}
.textAlignTreeTable .p-treetable-tbody .fontBoldcolor {
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
}

.projectPlanCompoButtons {
  height: 32px;
  width: auto;
  border-radius: 20px !important;
  padding: 10px 18px 10px 18px;
  margin-right: 23px;
  font-weight: 500;
  font-size: 12px;
  color: #003da5;
  line-height: 12px;
}

.projectPlanCompoButtonsColor {
  color: #ffffff;
  background-color: #00a3e0;
}

.projectPlanCompoButtonsColor1 {
  color: #ffffff;
  background-color: #003da5;
}

.overrideIcon {
  cursor: pointer;
  margin-left: 5px;
}

.accordion.projectPlanAccordian {
  margin: 0px;
}
.accordion.projectPlanAccordian .accordion-item > .accordion-header {
  background-color: #f7f7f7;
}
.accordion.projectPlanAccordian .accordion-item > .accordion-header .accordion-button {
  background-color: #f7f7f7 !important;
}
.accordion.projectPlanAccordian .accordion-item > .accordion-header {
  position: relative !important;
}
.accordion.projectPlanAccordian .accordion-item > .accordion-header > button {
  height: 25px;
}
.accordion.projectPlanAccordian .accordion-item > .accordion-header > button::after {
  position: absolute !important;
  margin-left: 110px;
}

.columnHeader {
  width: max-content;
}

.approveDesignDialog {
  width: 722px;
  height: 429px;
  border-radius: 20px;
}
.approveDesignDialog .p-dialog-content {
  overflow-y: hidden !important;
}

.columnBorder {
  background-color: #fafcff;
  font-size: 14px;
  font-weight: 500;
  line-height: 13px;
  color: #595959;
}

.columnBorder > div {
  margin-top: 5px;
  border-right: 0.5px solid #acacac;
  text-align: center;
  min-width: fit-content;
}

.columnBorder > div:last-child {
  border-right: none;
}

.columnBorder1 > div {
  margin: 10px 0 0 0;
  text-align: center;
  color: #595959;
  font-size: 10px !important;
  line-height: 10px;
}
.columnBorder1 > div select {
  color: #595959;
  font-size: 10px !important;
  line-height: 10px;
  font-weight: 400 !important;
}
.columnBorder1 > div div > label {
  font-size: 10px !important;
}

.columnBorder2 > div {
  margin-bottom: 20px;
  text-align: center;
  color: #595959;
}
.columnBorder2 > div select {
  color: #595959;
  font-size: 10px !important;
  line-height: 10px;
  font-weight: 400 !important;
}
.columnBorder2 > div div > label {
  font-size: 10px !important;
}

.submitButton {
  padding-top: 10px !important;
  text-align: right;
}
.submitButton button {
  font-weight: 500 !important;
  height: 32px !important;
  width: 93px !important;
}

.submitButton > button {
  background-color: #003da5 !important;
  width: 93px;
  height: 40px;
  color: #fff !important;
  font-size: 12px;
  border-radius: 20px;
  padding: 10px 24px;
}

.dropdownStyles {
  width: inherit;
  border-color: #acacac;
  padding: 4px 5px;
  border-radius: 8px;
}

.textAlignLeft {
  text-align: left;
}

.visuallyHidden {
  visibility: hidden;
}

.approveDesignDiv {
  position: relative;
  border: 0.5px solid #acacac;
  height: 144px;
  width: 377.5px;
  margin-left: 142px;
  border-radius: 5px;
  padding: 13px 15px;
}

.approveDesignDiv::before,
.approveDesignDiv::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 160px;
  border: 11px solid transparent;
  border-bottom-color: #dddddd;
}

.approveDesignDiv::after {
  left: 161px;
  border: 10px solid transparent;
  border-bottom-color: #ffffff;
}

.approveDesignDivHeading {
  font-weight: 600;
  font-size: 14px;
  line-height: 13.44px;
  color: #595959;
  line-height: 33px !important;
}

.approveDesignDivData {
  font-weight: 400;
  font-size: 14px;
  line-height: 13.44px;
  color: #595959;
}

.approveDesignDiv2Data {
  margin-top: 11px;
}

div[disabled] {
  pointer-events: none;
  opacity: 0.7;
}

.p-autocomplete-dd .p-autocomplete-dropdown,
.p-autocomplete-dd .p-autocomplete-dropdown:hover {
  background: transparent;
  color: #6c757d;
  width: 3rem;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  border: none;
}

.p-calendar {
  position: relative;
  display: inline-flex;
  max-width: 100%;
  height: 32px !important;
}

.p-autocomplete {
  border: 1px solid #ced4da !important;
  border-radius: 6px;
  width: 100%;
  height: 32px !important;
}
.p-autocomplete.p-autocomplete-dd .p-autocomplete-input {
  border: 0;
}
.p-autocomplete.p-autocomplete-dd .p-autocomplete-input:enabled:focus {
  box-shadow: none;
}

.helpneeded_done {
  color: #03a000;
}

.helpneeded_inprocess {
  color: #ff0000;
}

#massUpdate {
  border-radius: 30px;
  margin-right: 5px;
}
#massUpdate.p-dropdown.active {
  background-color: #003da5;
}
#massUpdate.p-dropdown.active .p-dropdown-label.p-placeholder {
  color: white;
  font-size: 12px !important;
}
#massUpdate.p-dropdown .p-dropdown-label.p-placeholder {
  color: #003da5;
  font-size: 12px !important;
}

.btn-outline-primary {
  margin-right: 5px;
  border-color: #007bff;
  color: #007bff;
}
.btn-outline-primary:hover {
  background-color: white;
  color: #003da5;
}

.dropdown .btn:hover {
  color: white;
  background-color: #003da5;
  border-color: #003da5;
}

#massUpdateForm {
  position: relative;
}
#massUpdateForm .formWrapper {
  max-height: 344px;
  overflow-y: scroll;
  overflow-x: clip;
}
#massUpdateForm .check-message {
  display: flex;
  align-items: center;
}
#massUpdateForm .massUpdateFooter {
  display: flex;
  bottom: 10px;
  justify-content: flex-end;
  gap: 24px;
  padding-top: 10px;
}

.project-plan-wrapper .p-dropdown {
  width: 100%;
}

.infoButton {
  background: transparent;
  border: none;
  vertical-align: -webkit-baseline-middle;
  margin-left: 5px;
}

.iconsStyle_massupdate {
  cursor: pointer;
  margin-right: 3.3px;
  width: 24px;
  height: 20px;
}

.iconsStyle_massupdate.disabled {
  opacity: 0.45;
  filter: grayscale(100%);
  pointer-events: none;
  cursor: not-allowed;
}

.forceApproveAction {
  font-size: 1.2rem;
  color: #00b050;
  vertical-align: -webkit-baseline-middle;
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/Projects/ProjectPlan/index.scss"],"names":[],"mappings":"AAMA;EACE,8BAAA;EACA,sBAAA;AALF;;AAOA;EACE,8BAAA;EACA,gBAAA;EACA,uBAAA;AAJF;;AAOE;EACE,YAAA;AAJJ;AAOE;EACE,YAAA;AALJ;AAQE;EACE,YAAA;AANJ;AAQE;EACE,WAAA;AANJ;AAQE;EACE,YAAA;AANJ;;AAUA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;AAPF;;AAWA;EACE,yBAAA;AARF;;AAWA;EACE,2BAAA;AARF;;AAYA;EACE,YAAA;EACA,gBAAA;AATF;AAWE;EACE,yBAAA;EACA,gBAAA;AATJ;AAWI;EACE,YAAA;EACA,WAAA;AATN;AAWM;EACE,YAAA;EACA,gBAAA;AATR;AAaI;EAIE,0BAAA;AAdN;AAkBE;EACE,gBAAA;EACA,WA/EO;AA+DX;AA+BE;EACE,gBA7FY;AAgEhB;AA6CE;;;;EAIE,kBAAA;AA3CJ;AAgDE;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AA9CJ;AAsDE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AApDJ;AAuDE;EACE,sBAAA;EACA,0BAAA;AArDJ;AAuDI;EACE,cAAA;AArDN;;AA0DA;EACE,gBAAA;AAvDF;;AA0DA;EACE,WAAA;AAvDF;;AA0DA;EACE,cAAA;AAvDF;;AA0DA;EACE,gBAhKc;EAiKd,eAAA;EACA,iBAAA;AAvDF;;AA0DA,2DAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AAvDF;;AA0DA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAvDF;;AA2DA;EACE,YAAA;EAEA,eAAA;AAzDF;;AA+DA;EACE,aAAA;EACA,8BAAA;AA5DF;;AA+DA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AA5DF;;AA+DA;EACE,eAAA;AA5DF;;AA+DA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;AA5DF;;AA+DA;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;AA5DF;;AA+DA;EACE,eAAA;EACA,iBAAA;AA5DF;AA8DE;EAEE,yBAAA;AA7DJ;AAgEE;EACE,uBAAA;AA9DJ;;AAmEA;EACE,6BAAA;AAhEF;;AAmEA;EACE,0BAAA;EACA,4BAAA;EACA,yBAAA;AAhEF;;AAmEA;EACE,0BAAA;EACA,4BAAA;EACA,kCAAA;EACA,cAAA;AAhEF;;AAmEA;EACE,2BAAA;AAhEF;;AAoEA;EACE,cAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAjEF;;AAoEA;EACE,cAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAjEF;;AAoEA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAjEF;;AAoEA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAjEF;;AAuEA;EACE,yBAAA;AApEF;;AAuEA;EACE,yBAAA;AApEF;;AAuEA;EACE,yBAAA;AApEF;;AAuEA;EACE,yBAAA;AApEF;;AAuEA;EACE,cAAA;EACA,eAAA;AApEF;;AAwEE;EACE,cAAA;AArEJ;AAwEE;EACE,6BAAA;EACA,YAAA;AAtEJ;;AA4EI;EACE,YAAA;AAzEN;AA4EI;EACE,cAAA;AA1EN;AA+EI;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AA7EN;;AAkFA;EACE,YAAA;EAEA,WAAA;EACA,8BAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAEA,cAAA;EACA,iBAAA;AAjFF;;AAoFA;EACE,cAAA;EACA,yBAAA;AAjFF;;AAoFA;EACE,cAAA;EACA,yBAAA;AAjFF;;AAoFA;EACE,eAAA;EACA,gBAAA;AAjFF;;AAqFA;EACE,WAAA;AAlFF;AAoFE;EACE,yBAAA;AAlFJ;AAoFI;EACE,oCAAA;AAlFN;AAsFE;EACE,6BAAA;AApFJ;AAuFE;EACE,YAAA;AArFJ;AAwFE;EACE,6BAAA;EACA,kBAAA;AAtFJ;;AA0FA;EAEE,kBAAA;AAxFF;;AA4FA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAzFF;AA2FE;EACE,6BAAA;AAzFJ;;AA6FA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA1FF;;AA6FA;EACE,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,sBAAA;AA1FF;;AA6FA;EACE,kBAAA;AA1FF;;AA6FA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;EACA,iBAAA;AA1FF;AA6FE;EACE,cAAA;EACA,0BAAA;EACA,iBAAA;EACA,2BAAA;AA3FJ;AA8FE;EACE,0BAAA;AA5FJ;;AAgGA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;AA7FF;AAgGE;EACE,cAAA;EACA,0BAAA;EACA,iBAAA;EACA,2BAAA;AA9FJ;AAiGE;EACE,0BAAA;AA/FJ;;AAmGA;EACE,4BAAA;EACA,iBAAA;AAhGF;AAkGE;EACE,2BAAA;EACA,uBAAA;EACA,sBAAA;AAhGJ;;AAoGA;EACE,oCAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AAjGF;;AAoGA;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AAjGF;;AAoGA;EACE,gBAAA;AAjGF;;AAoGA;EACE,kBAAA;AAjGF;;AAoGA;EACE,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAjGF;;AAoGA;;EAEE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;EACA,4BAAA;AAjGF;;AAoGA;EACE,WAAA;EACA,8BAAA;EACA,4BAAA;AAjGF;;AAoGA;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,4BAAA;AAjGF;;AAoGA;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AAjGF;;AAoGA;EACE,gBAAA;AAjGF;;AAoGA;EACE,oBAAA;EACA,YAAA;AAjGF;;AAoGA;;EAEE,uBAAA;EACA,cAAA;EACA,WAAA;EACA,4BAAA;EACA,+BAAA;EACA,YAAA;AAjGF;;AAoGA;EAEE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,uBAAA;AAlGF;;AAqGA;EACE,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AAlGF;AAoGE;EACE,SAAA;AAlGJ;AAoGI;EACE,gBAAA;AAlGN;;AAwGA;EACE,cAAA;AArGF;;AAwGA;EACE,cAAA;AArGF;;AAwGA;EACE,mBAAA;EACA,iBAAA;AArGF;AAwGI;EACE,yBA5mBI;AAsgBV;AAyGQ;EACE,YAAA;EACA,0BAAA;AAvGV;AA6GM;EACE,cAxnBE;EAynBF,0BAAA;AA3GR;;AAiHA;EACE,iBAAA;EACA,qBAAA;EACA,cAAA;AA9GF;AAgHE;EACE,uBAAA;EACA,cAtoBM;AAwhBV;;AAmHE;EACE,YAAA;EACA,yBA7oBM;EA8oBN,qBA9oBM;AA8hBV;;AAoHA;EAOE,kBAAA;AAvHF;AAiHE;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AA/GJ;AAoHE;EACE,aAAA;EACA,mBAAA;AAlHJ;AAqHE;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,SAAA;EAEA,iBAAA;AApHJ;;AAyHE;EACE,WAAA;AAtHJ;;AA0HA;EACE,uBAAA;EACA,YAAA;EACA,uCAAA;EACA,gBAAA;AAvHF;;AA0HA;EACE,eAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAvHF;;AA0HA;EACE,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;AAvHF;;AA0HA;EACE,iBAAA;EACA,cAAA;EACA,uCAAA;EACA,gBAAA;AAvHF","sourcesContent":["$width100: 100%;\n$fontWeight500: 500;\n$fontWeight400: 400;\n$primary: #003da5;\n\n\n.wrap-free-text {\n  white-space: normal !important;\n  word-break: break-word;\n}\n.nowrap-free-text {\n  white-space: nowrap !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.projectPlanTable {\n  .task-field-width {\n    width: 300px;\n  }\n\n  .non-task-width {\n    width: 140px;\n  }\n\n  .role-field-width {\n    width: 160px;\n  }\n  .customized-min-width {\n    width: 90px;\n  }\n  .taskDuration-min-width {\n    width: 110px;\n  }\n}\n\n.p-confirm-popup {\n  position: absolute;\n  top: 12% !important;\n  left: 0% !important;\n}\n\n// Datepicker for ProjectSetUp component Style Start\n.p-datepicker table td {\n  padding: 0.2px !important;\n}\n\n.p-button:focus {\n  box-shadow: none !important;\n}\n\n// Datepicker for ProjectSetUp component Style End\n.myProjectAnddAllProjectList {\n  height: 100%;\n  overflow: hidden;\n\n  .p-treetable {\n    height: calc(100% - 90px);\n    overflow: hidden;\n\n    > .p-treetable-wrapper {\n      height: 100%;\n      width: 100%;\n\n      .p-treetable-scrollable-view {\n        height: 100%;\n        overflow: hidden;\n      }\n    }\n\n    &.searchWithTreeTable\n      > .p-treetable-wrapper\n      .p-treetable-scrollable-view\n      .p-treetable-scrollable-body {\n      height: calc(100% - 100px);\n    }\n  }\n\n  .p-datatable > .p-datatable-wrapper {\n    overflow: scroll;\n    width: $width100;\n  }\n\n  // .p-datatable-table {\n  //   line-height: 15px;\n  // }\n\n  // .p-column-title {\n  //   font-weight: $fontWeight500;\n  // }\n\n  // .p-column-title > div {\n  //   display: flex;\n  // }\n\n  .p-datatable-tbody {\n    font-weight: $fontWeight400;\n  }\n\n  // th:after,\n  // td:after {\n  //   // content: \"\";\n  //   // display: block;\n  //   // height: 100%;\n  //   // width: 0.8px;\n  //   // background-color: #acacac;\n  //   // position: absolute;\n  //   // top: 0%;\n  //   // right: 0;\n  //   // border-right: 2px;\n  // }\n\n  td,\n  table .p-datatable .p-datatable-tbody > tr > td,\n  th,\n  tr {\n    position: relative;\n    // border: 0 !important;\n    // height: 40px;\n  }\n\n  .input-duration > input {\n    max-width: 70px;\n    border-radius: 5px;\n    text-align: center;\n    height: 25px;\n  }\n\n  // .form-control:focus,\n  // .p-inputwrapper-filled {\n  //   border: none;\n  // }\n\n  .task-link {\n    color: #003da5;\n    cursor: pointer;\n    line-height: 15px;\n    line-break: anywhere;\n  }\n\n  table .p-inputtext {\n    width: 100% !important;\n    font-size: 12px !important;\n\n    &.p-autocomplete-input {\n      padding: 0 5px;\n    }\n  }\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.p-checkbox {\n  margin: 8px;\n}\n\n.p-checkbox-checked + label {\n  color: #003da5;\n}\n\n.ml-2 {\n  font-weight: $fontWeight400;\n  font-size: 14px;\n  line-height: 17px;\n}\n\n/* badge used for wave name display in project plan table */\n.wave-name-badge {\n  display: flex;              // make element fill its container\n  align-items: center;        // vertical center\n  justify-content: center;    // horizontal center\n  padding: 8px 16px;          // balanced padding all around\n  width: 100%;                // take up full cell width\n  box-sizing: border-box;     // include padding in width calculation\n  text-align: center;\n  height: 100%;               // ensure full height if needed\n}\n\n.wave-name-badge_dependency_mapping {\n  display: flex;              // make element fill its container\n  align-items: center;        // vertical center\n  justify-content: center;    // horizontal center\n  padding: 8px 16px;          // balanced padding all around\n  width: 100%;                // take up full cell width\n  box-sizing: border-box;     // include padding in width calculation\n  text-align: center;\n  height: 100%;               // ensure full height if needed\n  margin-top: -10px; // adjust as needed to align with other content\n}\n\n// Filter and Save buttons disabled\nimg[disabled] {\n  opacity: 0.5;\n  // pointer-events: none;\n  cursor: no-drop;\n}\n\n// ProjectList Styles End\n\n// ConfirmationPopUp Styles Start\n.clearAllFilterMainDiv {\n  display: flex;\n  padding: 10.56px 22px 22px 2px;\n}\n\n.clearAllFilterDiv {\n  line-height: 12px;\n  justify-items: end;\n  display: flex;\n  position: absolute;\n  right: 22px;\n  top: 18px;\n}\n\n.clearAllFilter {\n  cursor: pointer;\n}\n\n.clearAllFilterIcon {\n  cursor: pointer;\n  position: absolute;\n  right: 5px;\n}\n\n.sortAndFrozen {\n  padding: 0 22px 22px 2px;\n  cursor: pointer;\n  line-height: 12px;\n}\n\n.multiSelect {\n  cursor: pointer;\n  line-height: 10px;\n\n  .p-placeholder {\n    // font-size: 8px !important;\n    color: #595959 !important;\n  }\n\n  .p-multiselect {\n    width: 124px !important;\n    // height: 16px !important;\n  }\n}\n\n.p-overlaypanel {\n  position: absolute !important;\n}\n\n.p-multiselect-item {\n  font-size: 10px !important;\n  line-height: 12px !important;\n  padding: 0px 0 !important;\n}\n\n.p-inputtext {\n  font-size: 10px !important;\n  line-height: 12px !important;\n  font-family: Montserrat !important;\n  color: #000000;\n}\n\n.apply-filter-text {\n  color: \"#003DA5\" !important;\n}\n\n// ProjectPlan Styles Start\n.duration {\n  color: #9a9898;\n  background-color: #ffffff !important;\n  width: 38px;\n  height: 20px;\n  border-color: #9a9898;\n  border-radius: 4px;\n  padding: 0px;\n  font-weight: 400;\n  font-size: 10px;\n}\n\n.helpNeeded {\n  color: #ffffff;\n  background-color: #01d309 !important;\n  width: 48px;\n  height: 20px;\n  border: none;\n  border-radius: 4px;\n  padding: 0px;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.iconsStyle {\n  cursor: pointer;\n  margin-right: 3.3px;\n  width: 13.33px;\n  height: 13.33px;\n}\n\n.iconsTextStyle {\n  color: #03a000;\n  font-size: 10px;\n  line-height: 12px;\n  cursor: pointer;\n  // margin-right: 3.3px;\n  // width: 13.33px;\n  // height: 13.33px;\n}\n\n.iconInprogress {\n  color: #003da5 !important;\n}\n\n.iconLock {\n  color: #595959 !important;\n}\n\n.iconAwaiting {\n  color: #d37302 !important;\n}\n\n.iconRejected {\n  color: #ff0000 !important;\n}\n\n.TaskStyles {\n  color: #003da5;\n  cursor: pointer;\n}\n\n.projectplan-calender {\n  .p-calendar {\n    display: block;\n  }\n\n  .p-inputtext {\n    border-radius: 4px !important;\n    height: 32px;\n  }\n}\n\n.textAlignTreeTable {\n  .p-treetable-thead {\n    .cursorMove {\n      cursor: move;\n    }\n\n    .fontBoldcolor {\n      color: #145392;\n    }\n  }\n\n  .p-treetable-tbody {\n    .fontBoldcolor {\n      font-weight: bold;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n  }\n}\n\n.projectPlanCompoButtons {\n  height: 32px;\n  // width: 86px;\n  width: auto;\n  border-radius: 20px !important;\n  padding: 10px 18px 10px 18px;\n  margin-right: 23px;\n  font-weight: 500;\n  font-size: 12px;\n  // background-color: #acacac !important;\n  color: #003da5;\n  line-height: 12px;\n}\n\n.projectPlanCompoButtonsColor {\n  color: #ffffff;\n  background-color: #00a3e0;\n}\n\n.projectPlanCompoButtonsColor1 {\n  color: #ffffff;\n  background-color: #003da5;\n}\n\n.overrideIcon {\n  cursor: pointer;\n  margin-left: 5px;\n}\n\n// ProjectPlan Styles End\n.accordion.projectPlanAccordian {\n  margin: 0px;\n\n  .accordion-item > .accordion-header {\n    background-color: #f7f7f7;\n\n    .accordion-button {\n      background-color: #f7f7f7 !important;\n    }\n  }\n\n  .accordion-item > .accordion-header {\n    position: relative !important;\n  }\n\n  .accordion-item > .accordion-header > button {\n    height: 25px;\n  }\n\n  .accordion-item > .accordion-header > button::after {\n    position: absolute !important;\n    margin-left: 110px;\n  }\n}\n\n.columnHeader {\n  // display: flex;\n  width: max-content;\n}\n\n// APrrove Dialog Styles Start\n.approveDesignDialog {\n  width: 722px;\n  height: 429px;\n  border-radius: 20px;\n\n  .p-dialog-content {\n    overflow-y: hidden !important;\n  }\n}\n\n.columnBorder {\n  background-color: #fafcff;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 13px;\n  color: #595959;\n}\n\n.columnBorder > div {\n  margin-top: 5px;\n  border-right: 0.5px solid #acacac;\n  text-align: center;\n  min-width: fit-content;\n}\n\n.columnBorder > div:last-child {\n  border-right: none;\n}\n\n.columnBorder1 > div {\n  margin: 10px 0 0 0;\n  text-align: center;\n  color: #595959;\n  font-size: 10px !important;\n  line-height: 10px;\n\n  // min-width: fit-content;\n  select {\n    color: #595959;\n    font-size: 10px !important;\n    line-height: 10px;\n    font-weight: 400 !important;\n  }\n\n  div > label {\n    font-size: 10px !important;\n  }\n}\n\n.columnBorder2 > div {\n  margin-bottom: 20px;\n  text-align: center;\n  color: #595959;\n\n  // min-width: fit-content;\n  select {\n    color: #595959;\n    font-size: 10px !important;\n    line-height: 10px;\n    font-weight: 400 !important;\n  }\n\n  div > label {\n    font-size: 10px !important;\n  }\n}\n\n.submitButton {\n  padding-top: 10px !important;\n  text-align: right;\n\n  button {\n    font-weight: 500 !important;\n    height: 32px !important;\n    width: 93px !important;\n  }\n}\n\n.submitButton > button {\n  background-color: #003da5 !important;\n  width: 93px;\n  height: 40px;\n  color: #fff !important;\n  font-size: 12px;\n  border-radius: 20px;\n  padding: 10px 24px;\n}\n\n.dropdownStyles {\n  width: inherit;\n  border-color: #acacac;\n  padding: 4px 5px;\n  border-radius: 8px;\n}\n\n.textAlignLeft {\n  text-align: left;\n}\n\n.visuallyHidden {\n  visibility: hidden;\n}\n\n.approveDesignDiv {\n  position: relative;\n  border: 0.5px solid #acacac;\n  height: 144px;\n  width: 377.5px;\n  margin-left: 142px;\n  border-radius: 5px;\n  padding: 13px 15px;\n}\n\n.approveDesignDiv::before,\n.approveDesignDiv::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 160px;\n  border: 11px solid transparent;\n  border-bottom-color: #dddddd;\n}\n\n.approveDesignDiv::after {\n  left: 161px;\n  border: 10px solid transparent;\n  border-bottom-color: #ffffff;\n}\n\n.approveDesignDivHeading {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 13.44px;\n  color: #595959;\n  line-height: 33px !important;\n}\n\n.approveDesignDivData {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 13.44px;\n  color: #595959;\n}\n\n.approveDesignDiv2Data {\n  margin-top: 11px;\n}\n\ndiv[disabled] {\n  pointer-events: none;\n  opacity: 0.7;\n}\n\n.p-autocomplete-dd .p-autocomplete-dropdown,\n.p-autocomplete-dd .p-autocomplete-dropdown:hover {\n  background: transparent;\n  color: #6c757d;\n  width: 3rem;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n  border: none;\n}\n\n.p-calendar {\n  //border: 1px solid #ced4da !important;\n  position: relative;\n  display: inline-flex;\n  max-width: 100%;\n  height: 32px !important;\n}\n\n.p-autocomplete {\n  border: 1px solid #ced4da !important;\n  border-radius: 6px;\n  width: 100%;\n  height: 32px !important;\n\n  &.p-autocomplete-dd .p-autocomplete-input {\n    border: 0;\n\n    &:enabled:focus {\n      box-shadow: none;\n    }\n  }\n}\n\n// APrrove Dialog Styles End\n.helpneeded_done {\n  color: #03a000;\n}\n\n.helpneeded_inprocess {\n  color: #ff0000;\n}\n\n#massUpdate {\n  border-radius: 30px;\n  margin-right: 5px;\n\n  &.p-dropdown {\n    &.active {\n      background-color: $primary;\n\n      .p-dropdown-label {\n        &.p-placeholder {\n          color: white;\n          font-size: 12px !important;\n        }\n      }\n    }\n\n    .p-dropdown-label {\n      &.p-placeholder {\n        color: $primary;\n        font-size: 12px !important;\n      }\n    }\n  }\n}\n\n.btn-outline-primary {\n  margin-right: 5px;\n  border-color: #007bff;\n  color: #007bff;\n\n  &:hover {\n    background-color: white;\n    color: $primary;\n  }\n}\n\n.dropdown {\n  .btn:hover {\n    color: white;\n    background-color: $primary;\n    border-color: $primary;\n  }\n}\n\n#massUpdateForm {\n  .formWrapper {\n    max-height: 344px;\n    overflow-y: scroll;\n    overflow-x: clip;\n  }\n\n  position: relative;\n\n  .check-message {\n    display: flex;\n    align-items: center;\n  }\n\n  .massUpdateFooter {\n    display: flex;\n    bottom: 10px;\n    justify-content: flex-end;\n    gap: 24px;\n    // margin: 5px 0px;\n    padding-top: 10px;\n  }\n}\n\n.project-plan-wrapper {\n  .p-dropdown {\n    width: 100%;\n  }\n}\n\n.infoButton {\n  background: transparent;\n  border: none;\n  vertical-align: -webkit-baseline-middle;\n  margin-left: 5px;\n}\n\n.iconsStyle_massupdate {\n  cursor: pointer;\n  margin-right: 3.3px;\n  width: 24px;\n  height: 20px;\n}\n\n.iconsStyle_massupdate.disabled {\n  opacity: 0.45;\n  filter: grayscale(100%);\n  pointer-events: none;\n  cursor: not-allowed;\n}\n\n.forceApproveAction {\n  font-size: 1.2rem;\n  color: #00b050;\n  vertical-align: -webkit-baseline-middle;\n  margin-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
